import { useState } from 'react';
import { ScaleLoader } from 'react-spinners';
import { ReCalClient } from '../../../api/ReCalClient';
import tw from '../../../config/tailwind';
import { useToasts } from '../../../hooks/useToasts';
import Button from '../../shared/Button';
import DefaultModal from '../../shared/DefaultModal';
import FilePicker from '../../shared/FilePicker';
import InputValidationMessage from '../../shared/InputValidationMessage';

interface Props {
  visible: boolean;
  setVisible: (v: boolean) => void;
  callback?: () => void;
}

const ReCalTemplateUploadModal: React.FC<Props> = ({
  visible,
  setVisible,
  callback
}) => {
  const [file, setFile] = useState<File | null>(null);
  const [fileError, setFileError] = useState('');
  const [uploading, setUploading] = useState(false);
  const { addToast } = useToasts();

  const handleSubmit = async () => {
    if (!file) {
      setFileError('Please provide an valid excel file.');
      return;
    }
    setUploading(true);

    const res = await ReCalClient.updateTemplate(file);
    console.log(res);

    addToast({
      title: 'Success!',
      description: `${res.message}`,
      type: 'success',
    });
    if(callback){ callback() };
    setUploading(false);
    setVisible(false);
  };

  return (
    <DefaultModal
      visible={visible}
      setVisible={setVisible}
      title={'Upload New Recycling Calculator Template'}
    >
      {uploading ? (
        <div style={tw`font-sans flex flex-rows align-center items-center justify-center`}>
          <ScaleLoader height={26} width={3} style={tw`mr-6`} color={`#3CDBC0`} /><p>Uploading, please wait</p>
        </div>
      ) : (
        <>
          <div style={tw`font-sans`}>
            <p>Please Upload an excel file (xls / xlsx)</p>
            <FilePicker
              type={[
                `application/vnd.ms-excel`,
                `application/vnd.openxmlformats-officedocument.spreadsheetml.sheet`
              ]}
              label='Select File'
              setValue={(f) => {
                f && setFile(f);
                setFileError('');
              }}
              hasError={!!fileError}
            />
            {fileError && (
              <InputValidationMessage>{fileError}</InputValidationMessage>
            )}
          </div>
          <div>
            <Button disabled={!file} onPress={() => handleSubmit()}>
              Upload
            </Button>
          </div>
        </>
      )}
    </DefaultModal>
  );
};

export default ReCalTemplateUploadModal;